module.exports = __webpack_public_path__ + "img/IMG_8950.6162622e.jpg";